import { motion } from "framer-motion";
import { EPISODES, IMAGES } from "../data/content";

export const Vaarta = () => (
  <section
    id="vaarta"
    data-testid="vaarta-section"
    className="bg-samatva-lavender/40 border-y border-samatva-line py-28 md:py-40 px-6 md:px-12"
  >
    <div className="max-w-[1400px] mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16 md:mb-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-xs tracking-[0.35em] uppercase text-samatva-plum mb-6">
            Vaarta — Stories & Podcast
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight text-samatva-ink leading-[1.05]">
            वार्ता — the sacred act of{" "}
            <em className="text-samatva-plum">conversation.</em>
          </h2>
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 text-base font-light leading-relaxed text-samatva-muted"
        >
          Real voices from the community — on grief and joy, food and faith,
          mothers and fathers and children. Listen in, or write to us to share
          your own story.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative overflow-hidden rounded-[2.5rem] min-h-[420px] group"
        >
          <img
            src={IMAGES.vaarta}
            alt="A person meditating on a rock surrounded by water"
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-samatva-ink/85 via-samatva-ink/20 to-transparent" />
          <div className="absolute bottom-0 p-8 md:p-10">
            <p className="text-xs tracking-[0.3em] uppercase text-samatva-lilac mb-3">
              Featured Story
            </p>
            <h3 className="font-serif text-2xl md:text-3xl font-light text-samatva-cream leading-snug">
              “I stopped fixing myself, and started sitting with myself.”
            </h3>
            <p className="mt-3 text-sm font-light text-samatva-lavender/80">
              — Meera, community member since 2024
            </p>
          </div>
        </motion.div>

        <div className="lg:col-span-7 flex flex-col gap-6">
          {EPISODES.map((ep, i) => (
            <motion.div
              key={ep.title}
              data-testid={`podcast-embed-${ep.kind}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="bg-samatva-cream border border-samatva-line rounded-[2rem] p-6 md:p-8"
            >
              <div className="flex items-baseline justify-between gap-4 mb-5">
                <div>
                  <h3 className="font-serif text-xl md:text-2xl font-medium text-samatva-ink">
                    {ep.title}
                  </h3>
                  <p className="text-sm font-light text-samatva-muted mt-1">
                    {ep.guest}
                  </p>
                </div>
                <span className="shrink-0 text-[10px] tracking-[0.25em] uppercase text-samatva-plum border border-samatva-plum/30 rounded-full px-3 py-1">
                  {ep.kind === "youtube" ? "Video" : "Audio"}
                </span>
              </div>
              <div className="overflow-hidden rounded-2xl bg-samatva-lavender/40">
                {ep.kind === "youtube" ? (
                  <iframe
                    src={ep.embedUrl}
                    title={ep.title}
                    className="w-full aspect-video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                ) : (
                  <iframe
                    src={ep.embedUrl}
                    title={ep.title}
                    className="w-full"
                    height="152"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
